"use client";

import Link from "next/link";

export default function AffiliateClient() {
  return (
    <>
      <main className="max-w-4xl mx-auto px-4 py-16">
        {/* HEADER */}
        <div className="mb-12 text-center">
          <h1 className="text-3xl font-semibold">
            Affiliate Program
          </h1>
          <p className="text-sm text-gray-500 mt-2">
            Earn commissions by promoting our products and services.
          </p>
        </div>

        {/* INTRO */}
        <section className="border rounded-xl p-6 bg-white mb-10">
          <p className="text-sm text-gray-700 leading-relaxed">
            Our Affiliate Program allows individuals, creators, and businesses
            to earn commissions by referring customers to our online store or
            physical outlets. Whether you operate a website, social media page,
            or business network, you can monetize your audience by promoting
            trusted technology products and solutions.
          </p>
        </section>

        {/* HOW IT WORKS */}
        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-4">
            How It Works
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-sm">
            <div className="border rounded-lg p-5 bg-gray-50">
              <h3 className="font-medium mb-2">
                1. Sign Up
              </h3>
              <p className="text-gray-700">
                Register for the affiliate program and get access to your unique
                referral link.
              </p>
            </div>

            <div className="border rounded-lg p-5 bg-gray-50">
              <h3 className="font-medium mb-2">
                2. Promote
              </h3>
              <p className="text-gray-700">
                Share your referral link on your website, blog, social media,
                or directly with customers.
              </p>
            </div>

            <div className="border rounded-lg p-5 bg-gray-50">
              <h3 className="font-medium mb-2">
                3. Earn
              </h3>
              <p className="text-gray-700">
                Earn commission for every successful purchase made through your
                referral.
              </p>
            </div>
          </div>
        </section>

        {/* COMMISSION */}
        <section className="border rounded-xl p-6 bg-white mb-10">
          <h2 className="text-lg font-semibold mb-3">
            Commission Structure
          </h2>

          <ul className="list-disc list-inside text-sm text-gray-700 space-y-2">
            <li>
              Commission rates vary by product category and promotion period.
            </li>
            <li>
              Earnings are calculated on completed and non-refunded orders.
            </li>
            <li>
              Commissions are tracked automatically through your referral link.
            </li>
            <li>
              Minimum payout thresholds may apply.
            </li>
          </ul>
        </section>

        {/* PAYMENT */}
        <section className="border rounded-xl p-6 bg-gray-50 mb-10">
          <h2 className="text-lg font-semibold mb-3">
            Payout & Payments
          </h2>

          <p className="text-sm text-gray-700 leading-relaxed">
            Affiliate earnings are paid on a scheduled basis after verification.
            Payments may be made via bank transfer, mobile financial services,
            or other supported payout methods, depending on your location and
            eligibility.
          </p>
        </section>

        {/* RULES */}
        <section className="border rounded-xl p-6 bg-white mb-10">
          <h2 className="text-lg font-semibold mb-3">
            Program Guidelines
          </h2>

          <ul className="list-disc list-inside text-sm text-gray-700 space-y-2">
            <li>No misleading or false advertising is allowed.</li>
            <li>Self-referrals or fraudulent activities are prohibited.</li>
            <li>We reserve the right to review and approve affiliate accounts.</li>
            <li>Violation of terms may result in suspension or termination.</li>
          </ul>
        </section>

        {/* CTA */}
        <section className="border rounded-xl p-8 bg-gray-50 text-center">
          <h2 className="text-lg font-semibold mb-3">
            Join Our Affiliate Program
          </h2>
          <p className="text-sm text-gray-700 mb-6">
            Start earning today by promoting quality technology products and
            trusted services.
          </p>

          <Link
            href="/contact-us"
            className="inline-block px-6 py-2 rounded-lg bg-black text-white text-sm font-medium"
          >
            Apply Now
          </Link>
        </section>
      </main>
    </>
  );
}